var _g, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 250,
    viewBox: "0 0 271 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.547073
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.035 192.313C255.027 211.776 237.522 225.909 218.304 233.792C199.086 241.676 178.169 243.86 157.536 244.235C156.237 244.261 154.938 244.274 153.64 244.286C126.39 244.461 98.7583 241.295 73.4986 230.891C71.3274 229.999 69.1691 229.049 67.0302 228.047C38.8755 214.813 14.3072 190.833 4.79522 160.073C0.827598 147.246 -0.46479 133.612 0.142636 120.145C0.846988 104.636 4.25242 89.2885 9.95832 74.9687C19.5737 50.8588 35.903 25.7215 58.565 13.9672C113.052 -14.2784 165.09 5.99948 184.877 26.665C206.149 48.8815 214.362 85.1011 235.086 107.886C242.62 116.164 252.268 122.213 259.169 131.078C272.216 147.834 273.043 172.855 264.035 192.313Z",
    fill: "#E9EAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.128 223.398C217.955 224.83 217.782 226.263 217.608 227.695C217.602 227.736 217.667 227.736 217.672 227.695C217.846 226.263 218.019 224.83 218.192 223.398C218.198 223.357 218.133 223.357 218.128 223.398Z",
    fill: "#E3F2FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.192,
    cy: 154.717,
    r: 95.2831,
    fill: "#E24C4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.474 154.718C211.474 207.124 168.597 250.001 116.191 250.001C85.8201 250.001 59.0217 236.304 41.7515 214.27C57.8305 227.371 78.6737 235.113 101.303 235.113C153.709 235.113 196.586 192.236 196.586 139.83C196.586 117.201 188.845 96.3573 175.743 80.2783C197.778 97.5477 211.474 124.346 211.474 154.718Z",
    fill: "#E24C4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.666 198.189C156.093 201.762 150.137 201.762 146.564 198.189L116.193 167.817L85.8217 198.189C82.2487 201.762 76.2932 201.762 72.7203 198.189C69.1473 194.616 69.1473 188.66 72.7203 185.087L103.092 154.716L72.7203 124.345C69.1473 120.772 69.1473 114.816 72.7203 111.243C76.2932 107.67 82.2487 107.67 85.8217 111.243L116.193 141.615L146.564 111.243C150.137 107.67 156.093 107.67 159.666 111.243C163.239 114.816 163.239 120.772 159.666 124.345L129.294 154.716L159.666 185.087C163.239 188.66 163.239 194.615 159.666 198.189Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1ee66468634dcb848b177b201ab22cc0.svg";
export { ForwardRef as ReactComponent };